/**
 * Generate the route of an image based on if it is being hosted locally or not
 * @param imageName: filepath of image
 */
export function getImageSrc(imageName: string): string {
  if (window.location.hostname === 'localhost') {
    return `/assets/sms/${imageName}`;
  }
  return `https://vstatic-prod.apigateway.co/customer-voice-client/assets/sms/${imageName}`;
}
